import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Paging } from '@pineapplelab/paging';
import { isNullOrUndefined } from '@pineapplelab/util';

@Component({
  selector: 'app-paging-paginator',
  templateUrl: './paging-paginator.component.html',
  styleUrls: ['./paging-paginator.component.scss']
})
export class PagingPaginatorComponent {
  @Input() paging: Paging;
  @Input() hidePageSize: boolean;
  @Input() marginRight: boolean = true;
  @Output() pagingChanged = new EventEmitter<Paging>();

  itemsPerPageLabel: string = 'Elements by page.'
  nextPageLabel: string = 'Next page'
  previousPageLabel: string = 'Previous page'

  constructor() { }

  ngOnInit() {}

  nextPage() {
    this.paging.action = Paging.pagingAction.nextPage;
    this.emitPagingChanged();
  }

  previousPage() {
    this.paging.action = Paging.pagingAction.previousPage;
    this.emitPagingChanged();
  }

  changeSize(value: number) {
    this.paging.size = value;
    this.emitPagingChanged();
  }

  emitPagingChanged () {
    if (!isNullOrUndefined( this.paging.loadData ) && typeof this.paging.loadData === 'function') {
      this.paging.loadData();
    }
    this.pagingChanged.emit(this.paging);
  }

}
